<template>
  <div v-cloak>
    <Header></Header>
    <h4>{{ oonfooData.title }}</h4>
    <div class="lines"></div>
    <div class="infomsg">
      <span>
        <img src="../assets/fenzhan/biao.png" alt="" />
      </span>

      <span>
        {{ oonfooData.ctime | dateFormat }}
      </span>
      <span>
        <img src="../assets/fenzhan/dizhi.png" alt="" />
      </span>
      <span>{{ oonfooData.siteName }}</span>
      <span>
        <img src="../assets/fenzhan/yj.png" alt="" />
      </span>
      <span>
        {{ oonfooData.browseNum }}
      </span>
    </div>
    <!--内容-->
    <div class="countent1">
      <p v-html="oonfooData.content"></p>
    </div>
    <!--分页-->
    <div class="page w95">
      <div class="pageItem1">
        <van-icon name="coupon-o" size="30" />
      </div>
      <div class="pageItem2">
        <span v-for="item in tags" :key="item.id">{{ item.name }}</span>
      </div>
    </div>
    <!---->
    <div class="nextBtn w95">
      <p @click="upArticle(up.id)">上一篇</p>
      <div class="boxs"></div>
      <p @click="downArticle(down.id)">下一篇</p>
    </div>
    <Fotter></Fotter>
  </div>
</template>

<script>
import Header from "./Header.vue";
import Fotter from "./Fotter.vue";
import __Config from "../api/config";
import wx from "weixin-js-sdk";
export default {
  name: "ZhaokaoMoreDetail",
  components: {
    Header,
    Fotter,
  },
  data() {
    return {
      id: null,
      oonfooData: {},
      tags: [],
      up: {},
      down: {},
      myurl: '',
      disctitle: "",
    };
  },
  methods: {
    getDetailinfo() {
      this.$toast.loading({
        duration: 0,
        mask: true,
        message: "加载中...",
      });
      var that = this;
      this.$axios
        .get(__Config.api.getinfo, {
          params: {
            id: this.id,
            siteCode: this.$store.state.treeData.code,
            siteId: this.$store.state.treeData.id,
          },
        })
        .then(function (res) {
          that.$toast.clear();
          that.oonfooData = res.data.data.articleManager;
          that.disctitle = res.data.data.articleManager.title;
          that.tags = res.data.data.tags;
          that.up = res.data.data.up;
          that.down = res.data.data.down;
          that.shareWx();
        })
        .catch(function (err) {
          that.$toast.clear();
          console.log(err);
        });
    },
    upArticle(id) {
      if (id == 0) {
        this.$notify({ type: "danger", message: "没有上一篇" });
      } else {
        this.id = id;
        this.getDetailinfo();
      }
    },
    downArticle(id) {
      if (id == 0) {
        this.$notify({ type: "danger", message: "没有下一篇" });
      } else {
        this.id = id;
        this.getDetailinfo();
      }
    },
    //微信分享
    shareWx() {
      var that = this;
      var myurl = encodeURIComponent(location.href.split("#")[0]);
      this.$axios
        .post("http://pay.91yunshi.com/payment2/jsSign?url=" + myurl, {})
        .then(function (data) {
          wx.config({
            debug: false,
            appId: "wxc40a603712f455e0",
            timestamp: data.data.data.timestamp,
            nonceStr: data.data.data.nonceStr,
            signature: data.data.data.signature,
            jsApiList: [
              "onMenuShareAppMessage",
              "onMenuShareTimeline",
              "updateAppMessageShareData",
              "updateTimelineShareData",
            ],
          });

          wx.ready(function () {
            let shareData = {
              title:that.oonfooData.title,
              desc: that.oonfooData.contentPart,
              link: Location.href, //'http://mp.weixin.qq.com/mp/getmasssendmsg?__biz=MzUxMTc1OTk5Nw==#wechat_redirect',
              imgUrl: "http://pay.91yunshi.com/share/html/h5app/logo.png",
            };
console.log(shareData);
            if (wx.onMenuShareAppMessage) {
              wx.onMenuShareAppMessage(shareData);
              wx.onMenuShareTimeline(shareData);
            } else {
              wx.updateAppMessageShareData(shareData);
              wx.updateTimelineShareData(shareData);
            }
          });
          wx.error((res) => {
            // config信息验证失败会执行error函数
            alert("微信安全域名解析失败");
          });
        })
        .catch(function (err) {});
    },
  },
  created() {
    this.id = this.$route.query.id;
    // this.id = localStorage.getItem("Zhaokaoid");
  },
  mounted() {
    this.getDetailinfo();
  },
};
</script>

<style scoped>
@import url("../assets/css/articleDetail.css");
.countent1 {
  width: 98%;
  margin: 0 auto;
}
.countent1 p {
  font-size: 13px;
}
.countent1 img {
  width: 100%;
  height: 100%;
}
[v-cloak] {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/ZhaokaoMoreDetail.vue